import { createSlice } from "@reduxjs/toolkit";
import { getProjectCertifications } from "./thunk";

const getProjectCErtificationSlice = createSlice({
    name: "getProjectCertifications",
    initialState: {
        isLoading: false,
        isError: false,
        projectCertification: {},
    },
    extraReducers: (builder) => {
        builder.addCase(getProjectCertifications.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
        });
        builder.addCase(getProjectCertifications.fulfilled, (state, action) => {
            state.isLoading = false;
            state.projectCertification = action.payload;
        });
        builder.addCase(getProjectCertifications.rejected, (state) => {
            state.isError = true;
            state.isLoading = false;
        });
    }
});

export default getProjectCErtificationSlice.reducer;